export const composeUpsellActionRuntime = ({ baseRuntime, cometRuntime, connectorRuntime, contentRuntime, healthRuntime, subscriptionRuntime, }) => ({
    ...baseRuntime,
    ...cometRuntime,
    ...connectorRuntime,
    ...contentRuntime,
    ...healthRuntime,
    ...subscriptionRuntime,
});
//# sourceMappingURL=composeUpsellActionRuntime.js.map